import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import CalendarActions from 'agent_portal/actions/CalendarActions';
import classes from './ProviderAndLocationSelect.module.scss';

const onProviderEmploymentChange = selected =>
  CalendarActions.changeFocusedProviderEmployment({ providerEmploymentId: selected.value });

const ProviderAndLocationSelect = ({
  selectedProviderEmploymentId,
  providerOptions,
  selectedLocationId,
  locationOptions,
}) => (
  <div id="provider-and-location-select-wrapper" className={classes.container}>
    <div className={classes.select_container}>
      <Select
        value={selectedProviderEmploymentId}
        options={providerOptions}
        clearable={false}
        onChange={onProviderEmploymentChange}
      />
    </div>
    {/* <div className={classes.select_container}>
      <Select
        value={selectedLocationId}
        options={locationOptions}
        clearable={false}
        onChange={onLocationChange}
      />
    </div> */}
  </div>
);

ProviderAndLocationSelect.displayName = 'ProviderAndLocationSelect';

ProviderAndLocationSelect.propTypes = {
  selectedProviderEmploymentId: PropTypes.string,
  providerOptions: PropTypes.array,
  selectedLocationId: PropTypes.string,
  locationOptions: PropTypes.array,
};

function mapStateToProps({ calendar }) {
  const providerOptions = calendar.providerEmployments.map(pe => ({
    value: pe.providerEmploymentId,
    label: pe.providerName,
  }));
  const { selectedProviderEmploymentId, selectedLocationId } = calendar;

  const selectedProviderEmployment = calendar.providerEmployments.find(
    p => p.providerEmploymentId === selectedProviderEmploymentId
  );
  // console.log(selectedProviderEmployment);
  const locationOptions = selectedProviderEmploymentId
    ? selectedProviderEmployment.locations.map(loc => ({ value: loc.id, label: loc.name }))
    : [];
  return {
    selectedProviderEmploymentId,
    providerOptions,
    selectedLocationId,
    locationOptions,
  };
}

export default connect(mapStateToProps)(ProviderAndLocationSelect);
